"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _appSwitcher = _interopRequireDefault(require("../lib/app-switcher"));

var _reactRouter = _interopRequireDefault(require("react-router"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleDropdown", function (item, event) {
      event.preventDefault();

      if (_this.state.currentDropdown === item) {
        _this.setState({
          currentDropdown: null,
          selectedNav: null
        });
      } else {
        _this.setState({
          selectedNav: item,
          currentDropdown: item
        });
      }
    });

    _this.state = {
      activeNav: "",
      currentDropdown: null,
      selectedNav: null
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setActivePage();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      window.onpopstate = function (e) {
        _this2.setActivePage();
      };
    }
  }, {
    key: "activeNav",
    value: function activeNav(item) {
      this.setState({
        activeNav: item,
        currentDropdown: null,
        selectedNav: null
      });
    }
  }, {
    key: "setActivePage",
    value: function setActivePage() {
      var currentLocation = window.location.pathname.split("/")[1];
      var navItem = "";
      this.props.headerData.map(function (item) {
        if (item.link.charAt(0) === "/" && item.link.substring(1) === currentLocation) {
          navItem = item.activeNav;
        }

        item.subNavItems.map(function (subItem) {
          if (subItem.link.charAt(0) === "/" && subItem.link.substring(1) === currentLocation) {
            navItem = subItem.activeNav;
          }
        });
      });
      this.setState({
        activeNav: navItem
      });
    }
  }, {
    key: "getNavItemClass",
    value: function getNavItemClass(item) {
      if (this.state.activeNav === item || this.state.selectedNav === item) {
        if (item === "apps") {
          return "active app-switcher-link";
        }

        if (item === "profile") {
          return "icon-button active";
        }

        return "nav-item dropdown active";
      } else {
        if (item === "apps") {
          return "app-switcher-link";
        }

        if (item === "profile") {
          return "icon-button";
        }

        return "nav-item dropdown";
      }
    }
  }, {
    key: "getDropdown",
    value: function getDropdown(item) {
      if (this.state.currentDropdown === item) {
        return "show";
      } else {
        return "hidden";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement("header", {
        className: "ds-header app-logged-in"
      }, _react.default.createElement("nav", {
        className: "navbar large-nav-menu"
      }, _react.default.createElement(_reactRouterDom.Link, {
        to: "/",
        className: "navbar-brand",
        onClick: function onClick() {
          return _this3.activeNav('');
        }
      }, _react.default.createElement("div", {
        className: "header-logo"
      }, _react.default.createElement("div", {
        className: "header-home-logo"
      }, _react.default.createElement("i", {
        class: "fa fa-home",
        "aria-hidden": "true"
      })))), _react.default.createElement("div", {
        className: "collapse navbar-collapse",
        id: "navbarCollapse"
      }, _react.default.createElement("ul", {
        className: "navbar-nav"
      }, this.props.headerData.map(function (item, index) {
        if (item.link === "#") {
          return _react.default.createElement("li", {
            className: _this3.getNavItemClass(item.activeNav),
            key: "item-".concat(index)
          }, _react.default.createElement(_reactRouterDom.Link, {
            to: "",
            onClick: function onClick(event) {
              return _this3.toggleDropdown(item.activeNav, event);
            },
            className: "dropdown-toggle"
          }, item.label, _react.default.createElement("i", {
            className: "fa fa-angle-down"
          })), _react.default.createElement("ul", {
            className: "dropdown-menu " + _this3.getDropdown(item.activeNav)
          }, item.subNavItems.map(function (subItem, index) {
            return _react.default.createElement("li", {
              key: "subItem-".concat(index)
            }, _react.default.createElement(_reactRouterDom.Link, {
              to: subItem.link,
              onClick: function onClick() {
                return _this3.activeNav(subItem.activeNav);
              }
            }, subItem.label));
          })));
        } else {
          return _react.default.createElement("li", {
            className: _this3.getNavItemClass(item.activeNav),
            key: "item-".concat(index)
          }, _react.default.createElement(_reactRouterDom.Link, {
            to: item.link,
            onClick: function onClick() {
              return _this3.activeNav(item.activeNav);
            },
            className: "nav-link link"
          }, item.label));
        }
      }))), _react.default.createElement("div", {
        className: "icon-bar"
      }, _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "desktop-app-switcher"
      }, _react.default.createElement(_reactRouterDom.Link, {
        className: this.getNavItemClass('apps'),
        to: "#",
        onClick: function onClick(event) {
          return _this3.toggleDropdown('apps', event);
        }
      }, _react.default.createElement("span", {
        className: "app-switcher-text"
      }, _react.default.createElement("span", null, this.props.appSwitcherData.appName, " "), _react.default.createElement("i", {
        className: "fa fa-angle-down",
        "aria-hidden": "true"
      }))), _react.default.createElement("div", {
        className: "dropdown-content info-dropdown app-switcher-panel " + this.getDropdown('apps')
      }, _react.default.createElement(_appSwitcher.default, {
        data: this.props.appSwitcherData
      }))), _react.default.createElement("div", {
        className: "mobile-app-switcher"
      }, _react.default.createElement(_reactRouterDom.Link, {
        className: this.getNavItemClass('apps'),
        to: "#",
        onClick: function onClick(event) {
          return _this3.toggleDropdown('apps', event);
        }
      }, _react.default.createElement("i", {
        className: "app-switcher-waffle fa fa-th",
        "aria-hidden": "true"
      })), _react.default.createElement("div", {
        className: "dropdown-content info-dropdown app-switcher-panel " + this.getDropdown('apps')
      }, _react.default.createElement(_appSwitcher.default, {
        data: this.props.appSwitcherData
      })))), _react.default.createElement("div", null, _react.default.createElement(_reactRouterDom.Link, {
        to: "#",
        className: this.getNavItemClass('profile'),
        onClick: function onClick(event) {
          return _this3.toggleDropdown('profile', event);
        }
      }, _react.default.createElement("img", {
        className: "fa user-profile-photo",
        src: "https://cdn.damco.com/cortex/v1/images/icons/DefaultProfileImg32.png",
        alt: "profile"
      })), _react.default.createElement("div", {
        id: "dropdown1",
        className: "dropdown-content info-dropdown " + this.getDropdown('profile')
      }, _react.default.createElement("ul", {
        className: "dropdown-content-area"
      }, _react.default.createElement("li", {
        className: "dropdown-profile-picture"
      }, _react.default.createElement("img", {
        alt: "",
        src: this.props.userData.profileImage
      })), _react.default.createElement("li", {
        className: "dropdown-details"
      }, _react.default.createElement("p", null, _react.default.createElement("strong", null, this.props.userData.name), _react.default.createElement("br", null), this.props.userData.email, _react.default.createElement("br", null), this.props.userData.company))), _react.default.createElement("div", {
        className: "dropdown-profile-role vertical-form"
      }, _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, "Role"), _react.default.createElement("select", {
        className: "form-control"
      }, this.props.userData.roles.map(function (item, index) {
        return _react.default.createElement("option", {
          key: index
        }, item);
      })))), _react.default.createElement("div", {
        className: "dropdown-button-footer nav-dropdown-footer"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button-large button-transparent",
        onClick: function onClick() {
          return window.location = _this3.props.userData.profileLink;
        }
      }, "View Profile"), _react.default.createElement("button", {
        type: "button",
        className: "button-large button-transparent",
        onClick: this.props.logout
      }, "Logout")))))));
    }
  }]);

  return Header;
}(_react.Component);

var _default = Header;
exports.default = _default;